import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box } from '@livable/saas-react-components';
import { Container } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import BreadcrumbsBar from 'src/components/general/BreadcrumbsBar';
import { PropertyWelcomePage } from './PropertyWelcomePage';
import { PropertyInformationPage } from 'src/components/property/PropertyInformationPage';
import { PropertyContactInformation } from 'src/components/property/PropertyContactInformation';
import { PropertyFeeStructurePageV2 } from 'src/components/property/PropertyFeeStructurePageV2';
import { PropertyResidentsAndFeeSetup } from 'src/components/property/PropertyResidentsAndFeeSetup';
import { PropertyUtilitiesSetupPageV2 } from 'src/components/property/PropertyUtilitiesSetupPageV2';
import { PropertyPayoutDetailsPage } from 'src/components/property/PropertyPayoutDetailsPage';
import { PropertyUnitSetupPage } from 'src/components/property/PropertyUnitSetupPage';
import { PropertyConfirmPage } from './PropertyConfirmPage';
import AddNewPropertyStepper from 'src/components/property/AddNewPropertyStepper';
import { useStore } from 'src/stores';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { PROPERTY_STEPS, APPFOLIO_PROPERTY_STEPS } from 'src/constants/property';
import { useURLHandler } from 'src/utils/hooks';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
import useStyles from './styles';
export const PropertyAddPage = observer(_ref => {
  var _urlParams$get, _urlParams$get2, _steps$activeStep, _steps$activeStep2, _steps$activeStep3;
  let propertyIdExt = _ref.propertyIdExt,
    portfolioIdExt = _ref.portfolioIdExt,
    hideBreadcrumbs = _ref.hideBreadcrumbs,
    registerActionBack = _ref.registerActionBack,
    registerActionNext = _ref.registerActionNext;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const urlParams = new URLSearchParams(window.location.search);
  const notCompletedPropertyId = (_urlParams$get = urlParams.get('not_completed_id')) !== null && _urlParams$get !== void 0 ? _urlParams$get : propertyIdExt;
  const predefinedPortfolioId = (_urlParams$get2 = urlParams.get('portfolioId')) !== null && _urlParams$get2 !== void 0 ? _urlParams$get2 : portfolioIdExt;
  if (predefinedPortfolioId) store.addNewProperty.setPortfolioId(predefinedPortfolioId);
  const livablePropertyId = localStorage.getItem('livable_property_id');
  const propertyId = notCompletedPropertyId !== null && notCompletedPropertyId !== void 0 ? notCompletedPropertyId : livablePropertyId;
  const CURRENT_STEPS = store.company.companyFeatureStore.isAppfolio ? APPFOLIO_PROPERTY_STEPS : PROPERTY_STEPS;
  const breadcrumbArray = [{
    title: t('general.dashboard'),
    link: '/active_dashboard'
  }, {
    title: t('add_new_property_flow.add_new_property')
  }];
  const stepsList = {
    welcome: {
      label: t('general.welcome'),
      name: 'welcome'
    },
    unitSetup: {
      label: t('add_new_property_flow.unit_setup'),
      name: 'unit-setup'
    },
    confirm: {
      label: t('add_new_property_flow.confirm_property'),
      name: 'confirm'
    },
    utilities: {
      label: t('add_new_property_flow.utilities_setup'),
      name: 'utilities'
    },
    contact: {
      label: t('add_new_property_flow.contact_information'),
      name: 'Contact'
    },
    payoutDetails: {
      label: t('subscriptions.payment_information'),
      name: 'payout-details'
    },
    feeStructure: {
      label: t('add_new_property_flow.fee_structure'),
      name: 'fee-structure'
    },
    information: {
      label: t('add_new_property_flow.property_information'),
      name: 'information'
    },
    residentsAndFeeSetup: {
      label: t('add_new_property_flow.residents_fee_setup'),
      name: 'residents-and-fee-setup'
    }
  };
  let steps;
  if (store.company.companyFeatureStore.isAppfolio) {
    steps = [stepsList.information, stepsList.utilities, stepsList.unitSetup, stepsList.residentsAndFeeSetup, stepsList.payoutDetails, stepsList.confirm];
  } else {
    steps = [stepsList.welcome, stepsList.information, stepsList.feeStructure, stepsList.utilities, stepsList.unitSetup, stepsList.confirm];
  }
  if (localStorage.getItem('livable_demo_mode') !== 'Demo' && !store.company.companyFeatureStore.isAppfolio) {
    steps.splice(3, 0, stepsList.payoutDetails);
  }
  const stepNames = steps.map(step => step.name);
  let _useURLHandler = _objectSpread({}, useURLHandler(store.company.companyFeatureStore.isAppfolio ? 'information' : 'welcome', stepNames, _objectSpread({}, propertyId ? {
      not_completed_id: propertyId
    } : undefined))),
    handleSelectedTabChange = _useURLHandler.handleSelectedTabChange,
    selectedTab = _useURLHandler.selectedTab;
  const activeStep = () => {
    const activeStepIndex = steps.findIndex(step => step.name === selectedTab);
    const resolvedIndex = activeStepIndex === -1 ? 0 : activeStepIndex;
    store.addNewProperty.changeActiveStep(steps[resolvedIndex].name);
    return resolvedIndex;
  };
  const loadStep = async step => {
    switch (step) {
      case CURRENT_STEPS.FeeSetup:
        {
          await store.properties.getPropertyFeesV2Async.run({
            applyToStore: true,
            applyToHomeDashboard: false,
            propertyId
          });
          break;
        }
      case CURRENT_STEPS.PayoutDetails:
        {
          break;
        }
      case CURRENT_STEPS.UtilityConfiguration:
        {
          await store.properties.getPropertyUtilityProvidersV3Async.run({
            forceSelectedUpdate: true,
            propertyId
          });
          if (store.company.companyFeatureStore.isAppfolio) {
            var _glProperties$respons, _currentGlProperty$ut;
            const glProperties = await store.credentials.getAppfolioPropertiesAsync.run({});
            const currentGlProperty = glProperties === null || glProperties === void 0 || (_glProperties$respons = glProperties.response) === null || _glProperties$respons === void 0 ? void 0 : _glProperties$respons.find(glItem => glItem.propertyLivableId === propertyId);
            if (currentGlProperty !== null && currentGlProperty !== void 0 && currentGlProperty.rentGlAccountExternalId) {
              store.addNewProperty.utilitiesSetupV2.setRentGlId(currentGlProperty === null || currentGlProperty === void 0 ? void 0 : currentGlProperty.rentGlAccountExternalId);
            }
            if (currentGlProperty !== null && currentGlProperty !== void 0 && currentGlProperty.glAccountExternalId) {
              store.addNewProperty.utilitiesSetupV2.setGlobalGlId(currentGlProperty === null || currentGlProperty === void 0 ? void 0 : currentGlProperty.glAccountExternalId);
            }
            if (currentGlProperty !== null && currentGlProperty !== void 0 && currentGlProperty.accountsPayableGlAccountExternalId) {
              store.addNewProperty.utilitiesSetupV2.setAccountsPayableGlId(currentGlProperty === null || currentGlProperty === void 0 ? void 0 : currentGlProperty.accountsPayableGlAccountExternalId);
            }
            if (!!(currentGlProperty !== null && currentGlProperty !== void 0 && (_currentGlProperty$ut = currentGlProperty.utilityGlAccounts) !== null && _currentGlProperty$ut !== void 0 && _currentGlProperty$ut.length)) {
              store.credentials.batchSetUtilitiesGlSettings(currentGlProperty === null || currentGlProperty === void 0 ? void 0 : currentGlProperty.utilityGlAccounts, store.addNewProperty.utilitiesSetupV2.selectedUtilities);
            }
          }
          break;
        }
    }
  };
  const scrollToTargetRef = useRef();
  const handleStep = step => async () => {
    if (step <= store.addNewProperty.completedStep) {
      handleSelectedTabChange(stepNames[step]);
      // NOTE: making background call to fetch property Utilities from backend
      if (activeStep() !== step && propertyId) {
        return Promise.all([loadStep(step), loadStep(activeStep())]);
      }
    }
    if (scrollToTargetRef.current) scrollToTargetRef.current.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const props = {
    handleStep,
    notCompletedPropertyId,
    predefinedPortfolioId,
    registerActionBack,
    registerActionNext
  };
  const components = {
    welcome: /*#__PURE__*/React.createElement(PropertyWelcomePage, props),
    information: /*#__PURE__*/React.createElement(PropertyInformationPage, props),
    'fee-structure': /*#__PURE__*/React.createElement(PropertyFeeStructurePageV2, props),
    utilities: /*#__PURE__*/React.createElement(PropertyUtilitiesSetupPageV2, props),
    'unit-setup': /*#__PURE__*/React.createElement(PropertyUnitSetupPage, props),
    confirm: /*#__PURE__*/React.createElement(PropertyConfirmPage, props),
    Contact: /*#__PURE__*/React.createElement(PropertyContactInformation, props),
    'payout-details': /*#__PURE__*/React.createElement(PropertyPayoutDetailsPage, props),
    'residents-and-fee-setup': /*#__PURE__*/React.createElement(PropertyResidentsAndFeeSetup, props)
  };
  steps = steps.map(step => _objectSpread(_objectSpread({}, step), {}, {
    component: components[step.name]
  }));
  const fetchData = async () => {
    if (!notCompletedPropertyId) return;
    await store.portfolios.getPortfoliosDashboardAsync.run({
      storeCompany: true
    }, [notCompletedPropertyId]);
    const resp = await store.properties.getPropertySetupProgressAsync.run({
      propertyId: notCompletedPropertyId
    });
    if (!resp || !resp.response || !resp.response.currentPropertySetupStep) return;
    resp.response.currentPropertySetupStep = CURRENT_STEPS[resp.response.currentPropertySetupStep];
    if (resp.response.currentPropertySetupStep >= CURRENT_STEPS.ContactInformation) {
      await store.teamMembers.getCompanyTeamMembersAsync.run({
        companyId: localStorage.getItem(USER_SETTINGS_KEYS.company)
      });
      await store.account.getProfileAsync.run(false);
      await store.properties.getPropertyAsync.run({
        propertyId: notCompletedPropertyId
      });
      await store.homeDashboardStore.getCurrentCompany.fetchCompanyPortfoliosData({});
      // await store.properties.getPropertysContactsAsync.run({
      //   propertyId: notCompletedPropertyId,
      // });
    }
    if (resp.response.currentPropertySetupStep >= CURRENT_STEPS.FeeSetup) {
      await store.properties.getPropertyFeesV2Async.run({
        propertyId: notCompletedPropertyId,
        applyToHomeDashboard: false,
        applyToStore: true
      });
    }
    if (resp.response.currentPropertySetupStep >= CURRENT_STEPS.PayoutDetails) {
      if (store.account.featureFlagsStore.getIsNewPayoutEnabled) {
        await store.homeDashboardStore.getCurrentCompany.fetchCompanyPayoutMethods({
          customInProgressFetchId: notCompletedPropertyId
        });
      }
    }
    if (resp.response.currentPropertySetupStep >= CURRENT_STEPS.UtilityConfiguration) {
      await loadStep(CURRENT_STEPS.UtilityConfiguration);
    }
    if (resp.response.currentPropertySetupStep >= CURRENT_STEPS.UnitSetup) {
      await store.inUnitAmenities.getAllInUnitAmenitiesAsync.run();
      const buildingsData = await store.buildings.getBuildingAsync.run({
        propertyId: notCompletedPropertyId
      });
      if (buildingsData !== null && buildingsData !== void 0 && buildingsData.response) {
        var _singleElementOfArray;
        await store.units.getUnitsAsync.run({
          buildingId: (_singleElementOfArray = singleElementOfArray(buildingsData === null || buildingsData === void 0 ? void 0 : buildingsData.response)) === null || _singleElementOfArray === void 0 ? void 0 : _singleElementOfArray.id,
          applyToHomeDashboard: false
        });
      }
      await store.properties.getPropertyUtilityProvidersV3Async.run({
        propertyId: notCompletedPropertyId
      });
    }
    const nextStepIndex = resp.response.currentPropertySetupStep + 1;
    // When the last completed step is the final one (ConfirmProperty →
    // nextPropertySetupStep === null), `+1` overflows the steps array and
    // `stepNames[index]` is undefined, so the URL handler falls back to the
    // default (first) tab. Clamp to the last real step instead.
    const targetStepIndex = Math.min(nextStepIndex, stepNames.length - 1);
    store.addNewProperty.changeCompletedStep(nextStepIndex);
    handleStep(targetStepIndex)();
  };
  useEffect(() => {
    if (!!localStorage.getItem('livable_property_id') && !notCompletedPropertyId) {
      window.location.href = "/new_property?not_completed_id=".concat(localStorage.getItem('livable_property_id'));
      return;
    }
    fetchData();
    return () => {
      store.addNewProperty.resetStoreToInitValues();
      store.vendors.resetStore();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !hideBreadcrumbs && /*#__PURE__*/React.createElement(BreadcrumbsBar, {
    breadcrumbsArray: breadcrumbArray
  }), /*#__PURE__*/React.createElement(AddNewPropertyStepper, {
    activeStep: activeStep(),
    completedSteps: store.addNewProperty.completedStep,
    steps: steps,
    handleStep: handleStep,
    hideBreadcrumbs: hideBreadcrumbs
  }), /*#__PURE__*/React.createElement(Box, {
    className: classes.boxMainContainer
  }, /*#__PURE__*/React.createElement(Container, {
    variant: "narrow",
    ref: scrollToTargetRef,
    className: ((_steps$activeStep = steps[activeStep()]) === null || _steps$activeStep === void 0 ? void 0 : _steps$activeStep.name) === 'residents-and-fee-setup-remove' || ((_steps$activeStep2 = steps[activeStep()]) === null || _steps$activeStep2 === void 0 ? void 0 : _steps$activeStep2.name) === 'confirm' && store.company.companyFeatureStore.isAppfolio ? classes.fullWidth : ''
  }, (_steps$activeStep3 = steps[activeStep()]) === null || _steps$activeStep3 === void 0 ? void 0 : _steps$activeStep3.component)));
});